// Client error reporting, same clientErrors collection and shape v1 uses, so one screen in the
// office shows both apps' errors. Capped per session; never throws.
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import { ENV } from './env';

const seen = new Set<string>();
let count = 0;
let who: { uid: string; name: string; usersPath: string } | null = null;

export function setErrorReporter(session: { uid: string; name: string; usersPath: string } | null) { who = session; }

export function reportError(kind: string, message: unknown, stack?: unknown, extra: Record<string, unknown> = {}) {
  try {
    if (!who) return;
    const msg = String(message instanceof Error ? message.message : message).slice(0, 500);
    const key = msg.slice(0, 200);
    if (seen.has(key) || count >= 8) return;
    seen.add(key); count++;
    void addDoc(collection(db, who.usersPath.replace(/users$/, 'clientErrors')), {
      kind, message: msg, stack: String(stack ?? (message instanceof Error ? message.stack : '') ?? '').slice(0, 1500),
      ua: navigator.userAgent.slice(0, 180), uid: who.uid, name: who.name, app: 'v2', env: ENV.name, version: __APP_VERSION__,
      url: location.pathname + location.search, standalone: matchMedia('(display-mode: standalone)').matches, online: navigator.onLine,
      ...extra, at: serverTimestamp(),
    }).catch(() => {});
  } catch { /* never throw from the reporter */ }
}

export function installErrorReporting() {
  window.addEventListener('error', e => reportError('error', e.message || e.error, e.error?.stack, { file: e.filename, line: e.lineno }));
  window.addEventListener('unhandledrejection', e => reportError('unhandledrejection', e.reason, (e.reason as Error)?.stack));
}
